import * as React from 'react'
import styled, { css } from 'styled-components'
import { theme } from 'utils/styledHelper'

import FarEye from './Icons/FarEye'
import FarEyeSlash from './Icons/FarEyeSlash'
import { HtmlInputType, Input, PropsType } from './Input'

const iconCss = css`
  position: absolute;
  right: 1rem;
  bottom: calc(1.35rem - 8px);
  user-select: none;
  fill: ${theme('inputColor')};
  &:hover {
    fill: ${theme('inputColor')};
  }
`

const Eye = styled(FarEye)`
  ${iconCss};
`

const EyeSlash = styled(FarEyeSlash)`
  ${iconCss};
`

const PasswordInput = styled(Input)`
  input {
    padding-right: 3rem;
  }
`

type StateType = { type: HtmlInputType }

class Password extends React.Component<PropsType, StateType> {
  static defaultProps = Input.defaultProps

  constructor(props: PropsType) {
    super(props)
    this.state = { type: props.type ?? 'password' }
  }

  handleIconClick = () => {
    if (this.state.type === 'password') {
      this.setState({ type: 'text' })
    } else {
      this.setState({ type: 'password' })
    }
  }

  renderToggle = (disabled?: boolean) => {
    if (disabled === true) {
      return null
    }

    const props = {
      onClick: this.handleIconClick,
      selectable: true,
      size: '16px'
    }

    return this.state.type === 'password' ? <EyeSlash {...props} /> : <Eye {...props} />
  }

  render() {
    const { type } = this.state
    const { ref, renderSuffix } = this.props

    return (
      <PasswordInput
        {...this.props}
        ref={ref}
        renderSuffix={renderSuffix ?? this.renderToggle}
        type={type}
      />
    )
  }
}

// export default React.forwardRef<HTMLInputElement, PropsType>((props, ref) => (
//   <Password {...props} ref={ref} />
// ))
export default Password
